export const updateCheckedKeys = ({
  checkedKeys: oriCheckedKeys,
  halfCheckedKeys: oriHalfCheckedKeys,
  node,
  items,
  checked,
}) => {
  const checkedKeys = new Set(oriCheckedKeys);
  const halfCheckedKeys = new Set(oriHalfCheckedKeys);

  const updateParent = (parentId) => {
    if (!parentId) return;

    const parent = items.find((i) => i.id === parentId);

    if (parent) {
      const { children } = parent;

      let checkedChildren = 0;
      let uncheckedChildren = 0;

      children.forEach((child) => {
        if (checkedKeys.has(child.key)) {
          checkedChildren += 1;
        } else if (!halfCheckedKeys.has(child.key)) {
          uncheckedChildren += 1;
        }
      });

      if (children.length === checkedChildren) {
        checkedKeys.add(parent.key);
        halfCheckedKeys.delete(parent.key);
      } else if (children.length === uncheckedChildren) {
        checkedKeys.delete(parent.key);
        halfCheckedKeys.delete(parent.key);
      } else {
        checkedKeys.delete(parent.key);
        halfCheckedKeys.add(parent.key);
      }

      updateParent(parent.parentId);
    }
  };

  const setUnchecked = (node) => {
    checkedKeys.delete(node.key);

    if (node.children?.length) {
      node.children.forEach(setUnchecked);
    } else {
      checkedKeys.forEach((key) => {
        if (key.includes(node.key)) {
          checkedKeys.delete(key);
        }
      });
      halfCheckedKeys.forEach((key) => {
        if (key.includes(node.key)) {
          halfCheckedKeys.delete(key);
        }
      });
    }

    updateParent(node.parentId);
  };

  const setChecked = (node) => {
    checkedKeys.add(node.key);
    halfCheckedKeys.delete(node.key);

    if (node.children?.length) {
      node.children.forEach(setChecked);
    } else {
      halfCheckedKeys.forEach((key) => {
        if (key.includes(node.key)) {
          halfCheckedKeys.delete(key);
        }
      });
    }

    updateParent(node.parentId);
  };

  checked ? setChecked(node) : setUnchecked(node);

  return {
    checkedKeys,
    halfCheckedKeys,
  };
};
